<!--The content below is only a placeholder and can be replaced.-->
<!-- Update Popup -->
<div class="update-overlay" *ngIf="showUpdatePopup">
  <div class="update-popup">
    <div class="update-icon">🔄</div>
    <h3>New Version Available</h3>
    <p>A new version of the app has been detected.</p>
    <p class="logout-msg">Logging you out for a fresh update...</p>
    <p class="please-login">Please login again after reload.</p>
    <div class="countdown-bar-wrapper">
      <div class="countdown-bar" [style.width.%]="(countdown / 5) * 100"></div>
    </div>
    <p class="countdown-text">Reloading in <strong>{{ countdown }}s</strong></p>
  </div>
</div>

<!-- Notification Preference Prompt -->
<div class="notification-prompt-overlay" *ngIf="showNotificationPrompt">
  <div class="notification-prompt-popup">
    <div class="notification-prompt-icon">🔔</div>
    <h3>Enable Notifications</h3>
    <p>Would you like to enable notifications within the app?</p>
    <div class="notification-prompt-actions">
      <button class="btn-no" (click)="onNotificationChoice(false)">No</button>
      <button class="btn-yes" (click)="onNotificationChoice(true)">Yes</button>
    </div>
  </div>
</div>

<section>
  <router-outlet></router-outlet>
</section>
<agm-map [latitude]="lat" [longitude]="lng">
  <agm-marker  [latitude]="lat" [longitude]="lng"></agm-marker>
</agm-map>
